import React, { useEffect, useState } from "react";
import axios from "axios";
import useReveal from "../components/useReveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useReveal();
  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${API}/journal`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="page-journal" className="bg-bone pt-40 pb-32">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <p className="label">— Journal</p>
        <h1 className="display text-[12vw] md:text-[8rem] leading-[0.9] tracking-tighter mt-6">
          Notes from the <span className="italic font-light text-rust">studio.</span>
        </h1>
        <p className="mt-8 text-lg text-muted2 max-w-2xl">Writing on design, drafting, construction practice in Australia — and the occasional rant about council documentation.</p>

        <div className="mt-24 space-y-16">
          {posts.map((p, i) => (
            <article key={p.slug} data-testid={`journal-entry-${p.slug}`} className="reveal grid grid-cols-12 gap-10 items-center border-t border-ink/15 pt-16">
              <div className={`col-span-12 md:col-span-6 ${i % 2 ? "md:order-2" : ""}`}>
                <div className="overflow-hidden aspect-[16/10]">
                  <img src={p.cover} alt={p.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]" />
                </div>
              </div>
              <div className="col-span-12 md:col-span-6">
                <div className="flex items-center gap-3">
                  <span className="label">{p.category}</span>
                  <span className="text-ink/30">·</span>
                  <span className="label">{p.read_time}</span>
                  <span className="text-ink/30">·</span>
                  <span className="label">{new Date(p.date).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" })}</span>
                </div>
                <h2 className="display text-4xl md:text-5xl lg:text-6xl leading-tight mt-4">{p.title}</h2>
                <p className="mt-6 text-lg text-muted2 max-w-xl">{p.excerpt}</p>
                <button className="mt-8 inline-flex items-center gap-3 text-[12px] uppercase tracking-[0.22em] border-b border-ink pb-1 hover:text-rust hover:border-rust transition-colors">
                  Read full piece →
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
}
